import styled, { css, } from "styled-components";

import * as v from "../vars";
import { objMap, } from "../../../lib/util";

// --------------------------------------------------

export const bp = objMap(v.bps, (key, val) => ({
	min: (...cont) => css`
		@media (min-width: ${val.min}px) {
			${css(...cont)}
		}
	`,
	max: (...cont) => css`
		@media (max-width: ${val.max}px) {
			${css(...cont)}
		}
	`,
	only: (...cont) => css`
		@media (min-width: ${val.min}px) and (max-width: ${val.max}px) {
			${css(...cont)}
		}
	`,
}));

export const xs = bp.xs.only;
export const sm = bp.sm.only;
export const md = bp.md.only;
export const lg = bp.lg.only;

export const bpEach = (prop, vals) => css`
	${Object.keys(vals).map((key) => bp[key].only`${prop}: ${vals[key]};`)}
`;

export const bpEither = (prop, vals) => css`
	${xs`${prop}: ${vals.xs};`}
	${bp.sm.min`${prop}: ${vals.other};`}
`;



// WEBPACK FOOTER //
// ./src/components/style/mixins/bp.js